/// REACT ///
import { useEffect } from "react";
/// REDUX ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
/// ACTIONS ///
import { updateLocalUser } from "api/actions/authentication";
import { logout } from "api/actions/authentication";
/// MUI ///
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
/// STYLE ///
import { mainContentAreaStyle } from "styles/style";

export default function SubscriptionSetupConfirmation() {
    const dispatch = useAppDispatch();
    const { user } = useAppSelector((state) => state.authentication);

    useEffect(() => {
        dispatch(updateLocalUser({...user, payment_initialized: true, subscription_active: true}));
    }, [dispatch]);

    return (
      <Box sx={mainContentAreaStyle}>
        <Grid container sx={{width: "100%", paddingLeft: 3.5, paddingRight: 3.5}}>
          <Grid item xs={10}>
            <Grid item container>
              <Grid item xs={12}>
                  <Typography variant="body1">
                      <b>Thank You For Joining Arris</b>
                  </Typography>
              </Grid>
              <Grid item xs={12}>
                  <Typography variant="body2" sx={{marginTop: 1}}>
                      You should now have access to the software. If you don't see the navigation menu on the left side, please logout by clicking the button below and log back in.
                    </Typography>
              </Grid>
              <Grid item xs={12}>
                  <Typography variant="body2" sx={{marginTop: 1}}>
                    If you do see the menu, <a href="/" style={{textDecoration: "none"}}>click here</a> to go back to the dashboard and begin using the software. Please contact support if you have any questions.
                  </Typography>
              </Grid>
              <Grid item xs={12} sx={{paddingTop: "25px"}}>
                <Button onClick={() => dispatch(logout())} variant="contained">
                  Logout
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
}
